import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'button', 'message' ];

    connect() {
        this.buttonTarget.addEventListener('click', (e) => {
            e.preventDefault();
            this.copyTextToClipboard(this.buttonTarget.dataset.copy);   
        });
    }

    copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            this.fallbackCopyTextToClipboard(text);
            return;
        }

        navigator.clipboard.writeText(text);

        if(this.messageTarget) {
            this.showMessage();
        }
    }

    fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        
        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
      
        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
          
            if(this.messageTarget) {
                this.showMessage();
            }
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
      
        document.body.removeChild(textArea);
    }

    showMessage() {
        this.messageTarget.classList.remove('opacity-0');
        setTimeout(() => {
            this.messageTarget.classList.add('opacity-0');
        }, 1500);
    }
	
}
  